module.exports = __webpack_public_path__ + "static/media/19ESCAP32.1ae5ff99.jpg";